import { PermissionService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-recorder-management-setting-group',
  templateUrl: './recorder-management-setting-group.component.html',
  styleUrl: './recorder-management-setting-group.component.scss',
  standalone: false,
})
export class RecorderManagementSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  callRecorderEnabled: boolean = false;
  screenRecorderEnabled: boolean = false;

  canManageSettings: boolean = false;
  canAccessManagement: boolean = false;

  settingsDefinitionItems: SettingsDefinitionModel[] = [
    {
      label: 'Settings::RecorderManagement:Management:CallRecorderDevices',
      navigationData: ['administration', 'devices'],
      extraData: null,
      requiredPolicies: [PermissionConstants.CallRecorderManagement],
      forFeatures: [FeatureConstants.CallRecorder],
    },
    {
      label: 'Settings::RecorderManagement:Management:CallRecorderDeviceGroups',
      navigationData: ['administration', 'device-groups'],
      extraData: null,
      requiredPolicies: [PermissionConstants.CallRecorderManagement],
      forFeatures: [FeatureConstants.CallRecorder],
    },
    {
      label: 'Settings::RecorderManagement:Management:ScreenRecorderProfiles',
      navigationData: ['administration', 'profiles'],
      extraData: null,
      requiredPolicies: [PermissionConstants.ScreenRecorderManagement],
      forFeatures: [FeatureConstants.ScreenRecorder],
    },
  ];

  constructor(
    private featureService: FeatureService,
    private permissionService: PermissionService
  ) {
    this.callRecorderEnabled = this.featureService.isEnabled(FeatureConstants.CallRecorder);
    this.screenRecorderEnabled = this.featureService.isEnabled(FeatureConstants.ScreenRecorder);
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement
    );
    this.canAccessManagement =
      (this.callRecorderEnabled &&
        this.permissionService.getGrantedPolicy(PermissionConstants.CallRecorderManagement)) ||
      (this.screenRecorderEnabled &&
        this.permissionService.getGrantedPolicy(PermissionConstants.ScreenRecorderManagement));
  }

  ngOnInit(): void {
    if (this.callRecorderEnabled && this.canManageSettings) {
      this.activeTab = 1;
    } else if (this.screenRecorderEnabled && this.canManageSettings) {
      this.activeTab = 2;
    } else {
      this.activeTab = 3;
    }
  }
}
